import React, { useState, useEffect } from "react";
import Button from "../components/buttons/Button";
import Text from "../components/typography/Text";

const Pager = (props) => {
  const {
    Component,
    items,
    listClassname = "",
    perPage = 7,
    separator,
    separatorAtPosition = 0,
  } = props;
  const [pageIndex, setPageIndex] = useState(1);
  const pagesCount =
    items.length % perPage > 0
      ? Math.floor(items.length / perPage) + 1
      : Math.floor(items.length / perPage);

  const pageItems = items.slice((pageIndex - 1) * perPage, pageIndex * perPage);

  useEffect(() => {
    setPageIndex(1);
  }, [items]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageIndex]);

  return (
    <div className="oPager">
      <div className={`oPager_items ${listClassname}`}>
        {items &&
          pageItems.map((item, index) => {
            const showTitle =
              separatorAtPosition === index + (pageIndex - 1) * perPage;
            return (
              <>
                {showTitle && separator}
                <Component key={item.id || index} {...item} />
              </>
            );
          })}
      </div>
      {pagesCount > 1 && (
        <div className="oPager_bottom">
          <div className="oPager_buttons">
            {pageIndex > 1 && (
              <Button arrowLeft onClick={() => setPageIndex(pageIndex - 1)}>
                Previous page
              </Button>
            )}
            {pageIndex < pagesCount && (
              <Button arrowRight onClick={() => setPageIndex(pageIndex + 1)}>
                Next page
              </Button>
            )}
          </div>
          <div className="oPager_count">
            <Text>
              <div className="oPager_index">{pageIndex}</div> out of{" "}
              {pagesCount}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pager;
